<template>
    <div class="mainpage">
        <div class="container">
            <section class="mainpage__placeholder">
                <div class="mainpage__placeholder-title-wrapper">
                    <h2 class="mainpage__placeholder-title--text mainpage__placeholder-title">Компания «Терминал Врангель» оказывает транспортно-логистические услуги на Дальнем Востоке России</h2>
                    <h3 class="mainpage__placeholder-title--text mainpage__placeholder-subtitle">Организует морскую перевалку контейнерных грузов в бухте Врангеля в Приморском крае и железнодорожные перевозки</h3>
                </div>

                <img class="mainpage__placeholder-image" src="/images/main-placeholder.webp" alt="placeholder">
            </section>
        </div>
    </div>
</template>

<script>
import { localize } from '@/utils/i18n'

export default {
    name: 'mainpage',
    data () {
        return {
            lang: this.$root.lang,
            reportLang: this.$root.lang,
            langVersion: {
                'ru': 'Russian version',
                'en': 'English version',
                'cn': 'English version'
            },
            data: this.$root.app.components['main-page'],
            text: {
                news: localize({
                    'ru': 'Новости',
                    'en': 'News',
                    'cn': '新闻'
                }),
                newsAll: localize({
                    'ru': 'Все новости',
                    'en': 'All news',
                    'cn': '所有新闻'
                }),
                services: localize({
                    'ru': 'Услуги терминалов',
                    'en': 'Services',
                    'cn': '服务'
                }),
                more: localize({
                    'ru': 'Подробнее',
                    'en': 'Learn more',
                    'cn': '了解详情'
                }),
                moreShareprice: localize({
                    'ru': 'Подробнее',
                    'en': 'Learn more',
                    'cn': 'Learn more'
                }),
                portalTitle: localize({
                    'ru': 'Единый клиентский портал',
                    'en': 'Client portal',
                    'cn': '同一客户平台'
                }),
                signin: localize({
                    'ru': 'Войти в&nbsp;личный кабинет',
                    'en': 'Sign in',
                    'cn': '登入个人账户'
                }),
                portalText: localize({
                    'ru': 'Подать электронную заявку, отследить и&nbsp;подписать документы электронной подписью',
                    'en': 'Submit an&nbsp;electronic application, track and sign documents electronically',
                    'cn': '提交电子申请,以电子方式跟踪和签署文件'
                }),
                onlineServicesTitle: localize({
                    'ru': 'Online сервисы',
                    'en': 'Interactive tools',
                    'cn': '在线服务'
                }),
                onlineServicesText: localize({
                    'ru': 'Посмотреть информацию о судозаходах и поездах, отслеживание грузов',
                    'en': 'View information on calls and trains, cargo tracking',
                    'cn': '查询船舶和火车进港信息货物跟踪'
                }),
                contactsTitle: localize({
                    'ru': 'Контакты Глобал Портс',
                    'en': 'Global Ports Contacts',
                    'cn': 'Global Ports 联系方式'
                }),
                contactsText: localize({
                    'ru': 'Свяжитесь с нами любым удобным способом',
                    'en': 'You are welcome to contact us in any convenient way for you',
                    'cn': '您可以通过以下方式联系我们'
                }),
                sharePriceTitle: localize({
                    'ru': 'Котировки',
                    'en': 'Share price',
                    'cn': 'Share price'
                }),
                financialResultsTitle: localize({
                    'ru': 'Financial results',
                    'en': 'Financial results',
                    'cn': 'Financial results'
                }),
                onlineReport: {
                    'ru': 'Онлайн версия',
                    'en': 'Online version',
                    'cn': 'Online version'
                },
                pdfReport: {
                    'ru': 'PDF версия',
                    'en': 'PDF version',
                    'cn': 'PDF version'
                }
            },
            sharePriceSrc: localize({
                'ru': 'https://charts3.equitystory.com/teaser/globalports-v31/Russian/',
                'en': 'https://charts3.equitystory.com/teaser/globalports-v31/English/',
                'cn': 'https://charts3.equitystory.com/teaser/globalports-v31/English/'
            })
        }
    },
    computed: {
        services () {
            let services = {
                main: [],
                others: []
            }

            this.data.services.forEach((item, i) => {
                if (item.main) {
                    services.main.push(item)
                } else {
                    services.others.push(item)
                }
            })

            return services
        }
    },
    methods: {
        changeReportLang (lang) {
            if (this.$refs['report-dropdown']) this.$refs['report-dropdown'].toggle()
            this.reportLang = lang
        }
    }
}
</script>

<style lang="scss">
    .mainpage {
        $parent: &;

        margin-top: 2rem;
        margin-bottom: 4rem;

        &__placeholder {
            $parentPlaceholder: &;

            position: relative;

            display: flex;
            flex-direction: column-reverse;

            @include breakpoint(tablet) {
                gap: $token-spacers-mobile-xxl;
            }

            &-title-wrapper {
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                z-index: 1;

                display: flex;
                justify-content: space-evenly;
                align-items: center;
                flex-direction: column;

                @include breakpoint(tablet) {
                    position: relative;
                    align-items: flex-start;
                    gap: $token-spacers-mobile-xl;

                    right: auto;
                    bottom: auto;
                }

                #{$parentPlaceholder}-title--text {
                    color: #fff;
                    max-width: 64ch;
                    text-align: center;

                    @include breakpoint(tablet) {
                        color: $token-colors-dark-grey;
                        text-align: start;
                        margin: 0;
                    }
                }

                #{$parentPlaceholder}-title-title {
                    line-height: 120%;
                }
            }
        }

        &__card-titles--invisible {
            @media (max-width: 940px) and (min-width: $breakpoint-mobile) {
                .card__title {
                    display: none;
                }
            }
        }

        .ar-card {
            &__version {
                background-color: rgba(255, 255, 255, 0.9);
                color: black;
            }
        }
    }
</style>
